import {
  useActivateShopMutation,
  useDeactivateShopMutation,
} from '../store/shops-api';
import { useShowResponseStatus } from '@/shared';

export const useShopStatus = () => {
  const [activateShop, {
    isLoading: isActivateLoading,
    isSuccess: isActivateSuccess,
    isError: isActivateError,
  }] = useActivateShopMutation();

  const [deactivateShop, {
    isLoading: isDeactivateLoading,
    isSuccess: isDeactivateSuccess,
    isError: isDeactivateError,
  }] = useDeactivateShopMutation();

  const isLoading = isActivateLoading || isDeactivateLoading;
  const isSuccess = isActivateSuccess || isDeactivateSuccess;
  const isError = isActivateError || isDeactivateError;

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  return {
    activateShop,
    deactivateShop,
    isLoading,
  };
};
